export default "__VITE_ASSET__WHb8AVBU__"